import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './navigation-views/home/home.component';
import { AuthenticationGuard } from './guards/authentication.guard';
import { ResetRequestComponent } from './login/recover-login/reset-request/reset-request.component';
import { ResetResponseComponent } from './login/recover-login/reset-response/reset-response.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { SarComponent } from './navigation-views/sar/sar.component';
import { MlroComponent } from './navigation-views/mlro/mlro.component';
import { AuthorizeGuard } from './guards/authorize.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'app/home',
    pathMatch: 'full'
  },
  { path: 'login', component: LoginComponent },
  { path: 'resetlogin', component: ResetRequestComponent },
  {
    path: 'Recover_Credentials',
    component: ResetResponseComponent
  },
  {
    path: 'app',
    component: MainNavComponent,
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'sar', component: SarComponent },
      { path: 'statistics', component: MlroComponent, 
        canActivate: [AuthorizeGuard] },
      {
        path: 'case-manager',
        loadChildren: () => import('./case-manager/case-manager.module').then(m => m.CaseManagerModule)
      },
      {
        path: 'monitoring-manager',
        loadChildren: () => import('./monitoring-manager/monitoring-manager.module').then(m => m.MonitoringManagerModule)
      },
      {
        path: 'leadership',
        loadChildren: () => import('./leadership/leadership.module').then(m => m.LeadershipModule), 
        canActivate: [AuthorizeGuard]
      },
      {
        path: 'users-management',
        loadChildren: () => import('./users-management/users-management.module').then(m => m.UsersManagementModule), 
        canActivate: [AuthorizeGuard]
      },
      {
        path: 'audit-trail',
        loadChildren: () => import('./audit-trail/audit-trail.module').then(m => m.AuditTrailModule),
        canActivate: [AuthorizeGuard]
      },
      {
        path: 'user-settings',
        loadChildren: () => import('./user-settings/user-settings.module').then(m => m.UserSettingsModule)
      },
      {
        path: 'upload-data',
        loadChildren: () => import('./upload-data/upload-data.module').then(m => m.UploadDataModule)
      },
      {
        path: 'graph-analytics',
        loadChildren: () => import('./graph-analytics/graph-analytics.module').then(m => m.GraphAnalyticsModule)
      }
    ],
    canActivate: [AuthenticationGuard]
  }
];

@NgModule({
  imports: [
    RouterModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
